class BaseAddress {
  /**
   * @class
   * @param {BaseAddress} data
   */
  constructor(data) {
    this.street = data.street;
    this.street2 = data.street2;
    this.city = data.city;
    this.stateCode = data.stateCode;
    this.zip = data.zip;
    this.region = data.region;
  }
}

export class Address extends BaseAddress {
  /**
   * @class
   * @param {Address} data
   */
  constructor(data) {
    super(data);
    this.id = data.id;
  }
}

export class AddressCreation extends BaseAddress {}
